import { IModel } from "@/@types/models/model";

import { coreFields } from "./helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const Project: IModel = {
  title: "Projekti",
  apiPath: "projects/",
  forms: {
    default: {
      fields: [
        "sifra",
        "naziv",
      ],
    },
    update: {
      fields: [
        "id",
        "sifra",
        "naziv",
        "tag",
        "koef_kn",
        "gs_username",
        "cesium_folder",
        "cesium_config_file",
        "map_default_extent",
        "map_max_extent",
        "map_initial_view_center",
        "map_initial_view_zoom",
        "zap_docx_template",
        "zap_layer_dof",
        "zap_layer_objekt",
      ]
    }, 
    insert: {
      fields: [
        "id",
        "sifra",
        "naziv",
        "tag",
        "koef_kn",
        "gs_username",
        "cesium_folder",
        "cesium_config_file",
        "map_default_extent",
        "map_max_extent",
        "map_initial_view_center",
        "map_initial_view_zoom",
        "zap_docx_template",
        "zap_layer_dof",
        "zap_layer_objekt",
      ]
    }
  },
  listViews: {
    default: {
      fields: [
        "id",
        "sifra",
        "naziv",
        "tag",
        "koef_kn",
        "gs_username",
        "active",
        "created_on",
        "created_by",
        "modified_on",
        "modified_by",
      ],
    },
  },
  fields: [
    {
      title: "ID",
      source: "id",
      ttoken: "common.id",
      type: "numeric",
      idattr: true,
      validation: {
        required: true
      }
    },
    coreFields.active,
    {
      title: "Šifra",
      source: "sifra",
      ttoken: "projekti.sifra",
      type: "text",
      validation: {
        required: true
      }
    },
    {
      title: "Naziv",
      source: "naziv",
      ttoken: "projekti.naziv",
      type: "text",
      validation: {
        required: true
      }
    },
    {
      title: "Oznaka",
      source: "tag",
      ttoken: "projekti.tag",
      type: "text",
      validation: {
        required: true,
        maxLength: 30,
        regex: "tag"
      }
    },
    {
      title: "Koeficijent komunalne naknade",
      source: "koef_kn",
      ttoken: "projekti.koef_kn",
      type: "numeric",
      validation: {
        required: true
      }
    },
    {
      title: "Cesium config file",
      source: "cesium_config_file",
      ttoken: "projekti.cesium_conf",
      type: "text",
    },
    {
      title: "Cesium folder",
      source: "cesium_folder",
      ttoken: "projekti.cesium_folder",
      type: "text",
    },
    {
      title: "GeoServer username",
      source: "gs_username",
      ttoken: "projekti.gs_username",
      type: "text",
    },
    {
      title: "Map default extent",
      source: "map_default_extent",
      ttoken: "projekti.map_defauilt_extent",
      type: "text",
      placeholder: "208311,4608969,744179,5161549"
    },
    {
      title: "Map max extent",
      source: "map_max_extent",
      ttoken: "projekti.map_max_extent",
      type: "text",
      placeholder: "208311,4608969,744179,5161549"
    },
    {
      title: "Map initial view center",
      source: "map_initial_view_center",
      ttoken: "projekti.map_initial_view_center",
      type: "text",
      placeholder: "477174,4882262"
    },
    {
      title: "Map initial view zoom",
      source: "map_initial_view_zoom",
      ttoken: "projekti.map_initial_view_zoom",
      type: "numeric",
    },
    {
      title: "Zapisnici docx template",
      source: "zap_docx_template",
      ttoken: "projekti.zap_docx_template",
      type: "text",
    },
    {
      title: "Zapisnici naziv sloja - DOF",
      source: "zap_layer_dof",
      ttoken: "projekti.zap_layer_dof",
      type: "text",
    },
    {
      title: "Zapisnici naziv sloja - objekt",
      source: "zap_layer_objekt",
      ttoken: "projekti.zap_layer_objekt",
      type: "text",
    },
    {
      title: "operators",
      source: "operators",
      ttoken: "projekti.operators",
      type: "array"
    },
    {
      title: "Geoportal URL",
      source: "geoportal_url",
      ttoken: "projekti.geoportal_url",
      type: "text"
    },
    commonFields.wkt,
    coreFields.created_on,
    coreFields.created_by,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default Project;
